/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import NProgress from 'nprogress';
import Backbone from 'backbone';

import { userHasRole } from '@/util/RoleUtils';
import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import ErrorView from '@/views/ErrorView';

import OrderPackageDashboardPage from '../pages/OrderPackageDashboardPage';

export default async function ShowOrderPackageDashboardPage() {
  NProgress.start();
  try {
    if (userHasRole('CRS') || userHasRole('EPC') || userHasRole('Admin')) {
      NavUtils.navigate(`order-packages`);
    } else {
      showErrorView();
      return;
    }

    Scaffold.getRegion('content').show(
      new OrderPackageDashboardPage({
        model: new Backbone.Model({})
      })
    );
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Order Package Dashboard page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Order Package Dashboard page.'
      })
    })
  );
}